import React from "react";

import Section, { SectionItem } from "../../../common/Section";
import Layout from "../../../layout/Layout";
import RecommendItem from "./components/RecomendItem";
import { MdAddCircleOutline } from "react-icons/md";

import { items } from "./api";
import Paper from "@material-ui/core/Paper";

export default function RecommendationsFeed(props) {
  const renderItems = items => {
    return items.map(item => {
      return (
        <SectionItem>
          <RecommendItem item={item} />
        </SectionItem>
      );
    });
  };

  return (
    <Section title={"Recommendations & Support"}>
      <SectionItem>
        <Paper
          onClick={() => {}}
          style={{
            color: "#525252",
            position: "relative",
            width: "120px",
            height: "160px",
            cursor: "pointer"
          }}
        >
          <div
            style={{
              position: "relative",
              top: "34px",
              textAlign: "center"
            }}
          >
            <MdAddCircleOutline size={40} />
            <div
              style={{
                width: "100%",
                whiteSpace: "pre-wrap",
                fontSize: "18px"
              }}
            >
              Reach out to your community
            </div>
          </div>
        </Paper>
      </SectionItem>
      {renderItems(items)}
    </Section>
  );
}
